import { StyleSheet } from "@react-pdf/renderer"

export const shippingDataStyles = ()=>{

    const shippingData = StyleSheet.create({
        container: {
            height:30,
            marginTop:2,
            borderWidth: 1,
            flexDirection: 'row',
        },
        subContainer: {
            flex:1
        },
        titleContainer: {
            height: '40%',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottomWidth: 1,
        },
        title: {
            fontSize: 7,
            fontWeight: 700
        },
        dataContainer: {
            height: '60%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        data: {
            fontSize: 6
        }
    })

    return {
        shippingData
    }
}